module.exports = __webpack_public_path__ + "media/6s.130210c9.mp3";